import { updatedDiff } from 'deep-object-diff'
import isEmpty from 'lodash.isempty'

import {
  REVERTABLE_PRESET
} from '../actions/actionTypes'

import presetActionList from '../constants/presetActionList'
import { getOriginPreset } from '../utilities'

const presetDiff = store => next => action => {
  const result = next(action),
        state = store.getState()
  // this could live in MalletStationListener but we would have to ignore CRUD changes to state.presets
  if(presetActionList.includes(action.type)){
    const revertableDiff = updatedDiff(getOriginPreset(state), state.currentPreset)

    if(!isEmpty(revertableDiff)){
      store.dispatch({type: REVERTABLE_PRESET, diffLength: Object.keys(revertableDiff).length})
    } else {
      store.dispatch({type: REVERTABLE_PRESET, diffLength: false})
    }
  }

  return result
}

export default presetDiff
